import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { IWallet } from './interfaces';
import { MobileAgentServiceService } from 'src/app/shared/services/mobile-agent-service.service';
import { myCreditsMobileService } from 'src/app/shared/services/myCredits-mobile.service';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-my-credits',
  templateUrl: './my-credits.component.html',
  styleUrls: ['./my-credits.component.css'],
})
export class MyCreditsComponent implements OnInit {
  @Input() isLoggedIn = false;
  public showCreditsInfo: boolean = false;
  public showCredits: boolean = false;
  public operator: any;
  public currencyCode: string = '';
  public currencySymbol: string = '';
  public isMobile: boolean = false;

  @Input() public wallet: IWallet = {
    bonus: 0.0,
    credits: 0.0,
    total: 0.0,
  };

  constructor(
    private readonly elementRef: ElementRef,
    private readonly mobile: MobileAgentServiceService,
    private readonly myCreditsMobile: myCreditsMobileService,
    private readonly api: ApiService,
    private readonly messageService: MessageService,
    private readonly authService: AuthService
  ) {
    this.isMobile = this.mobile.isMobileDevice();
  }

  ngOnInit(): void {
    this.getoperatorConfig();
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
  }

  // public showCreditsAction(): void {
  //   this.showCredits ? (this.showCredits = false) : (this.showCredits = true);
  // }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (!this.isMobile) {
        this.showCredits = false;
        return;
      }
      if (this.showCredits) {
        this.showCredits = false;
        this.myCreditsMobile.setOrigen(this.showCredits);
      }
      
    }
  }

  hideMycredits(): void {
    this.showCredits = false;
  }

  public setShowCredits(): void {
    this.myCreditsMobile.setOrigen(true);
    this.showCredits = true;
  }

  private getoperatorConfig(): void {
    this.api.list(`${ApiCore.OPERATOR}/operator-config`).subscribe(
      (responseOperator) => {
        if (responseOperator.statusCode != 200) {
          this.messageService.add({
            key: 'bc',
            severity: 'error',
            summary: 'Error loading data',
          });
          return;
        }

        this.operator = responseOperator;
        this.currencyCode = responseOperator.data.currencyCode;
        this.currencySymbol = responseOperator.data.currencySymbol;
      },
      (error) => {
        this.messageService.add({
          key: 'bc',
          severity: 'error',
          summary: JSON.stringify(error),
        });
      }
    );
  }
  toggleCredits(){
    this.showCredits = !this.showCredits
  }
}
